import { ActivityIndicator, View } from 'react-native';
import { Redirect, Stack } from 'expo-router';
import { useAuth } from '@/hooks/useAuth';
import { getAuthHref } from '@/lib/routes';
import { RouteGateConnectionErrorState } from '@/components/route/RouteGate';
import { StyleSheet } from 'react-native-unistyles';

const styles = StyleSheet.create(() => ({
  loading: {
    alignItems: 'center',
    flex: 1,
    justifyContent: 'center',
  },
}));

export default function AppLayout() {
  const { isAuthenticated, isLoading, hasConnectionError, retry } = useAuth();

  if (isLoading) {
    return (
      <View style={styles.loading}>
        <ActivityIndicator size="large" />
      </View>
    );
  }

  if (hasConnectionError) {
    return <RouteGateConnectionErrorState onRetry={retry} />;
  }

  if (!isAuthenticated) {
    return <Redirect href={getAuthHref()} />;
  }

  return (
    <Stack screenOptions={{ headerShown: false, animation: 'slide_from_right' }} />
  );
}
